module.exports = __webpack_public_path__ + "img/OBCINA RADLJE OB DRAVI.894b8f12.png";